<template>

    <div class="nav">
        <div class="head">
            <div class="left">
                <div class="left-title">
                    <img :src="language=='EN'?require('../../public/image/navENLogo.png'):require('../../public/image/ruiji_logo2.png')" alt="" class="left-title-pc">
                    <img :src="language=='EN'?require('../../public/image/navENLogo.png'):require('../../public/image/phoneLogo.png')" alt="" class="left-title-phone">
                    
                    <!-- <div>广东瑞集物联网科技有限公司</div> -->
                </div>
                <!-- <changeLanguage class="phoneChange"></changeLanguage> -->
                <!-- <i class="el-icon-s-unfold icon" ref="menu" @click="openMenu"></i> -->
            </div>
            <!-- <div class="headTitle">广东瑞集物联网科技有限公司</div> -->

            <div class="firstHead">
                <!-- <i class="el-icon-arrow-left icon3" @click="prev" ref="prev" :class="{ 'active2': count == 0 }"></i> -->
                <div class="ul">
                    <div class="li List" v-for="item of routerList" :key="item.path" @click.capture="change(item)">
                        <a>{{ $t('navTitle', { title: item.meta.title, enTitle: item.meta.enTitle }) }}</a>
                        <div class="line" :class="{ 'active':$route.path.includes(item.path)    }"></div>
                        <ul class="content">
                            <li v-for="hhh of item.children" :key="hhh.path"
                                @click="toDetail(item.name, hhh.name, hhh.path)"
                                :class="{ 'productActive': childrenName == hhh.name }">
                                <a  style="margin: 0 0.5rem;">{{ $t('navTitle', { title: hhh.meta.title, enTitle: hhh.meta.title }) }}</a>

                            </li>
                        </ul>
                    </div>
                    
                </div>
                <changeLanguage style="margin: 0 0.5rem;"></changeLanguage>
                <!-- <i class="el-icon-arrow-right icon2" @click="next" ref="next"
                :class="{ 'active2': count == routerList.length - 1 }"></i> -->
            </div>

            <!-- <div class="phoneMenu" ref="phoneMenu">
            <div class="top" @click="closeMenu">
                <div class="top_icon"> <i class="el-icon-close"></i></div>
            </div>
            <div class="menu">
                <menuList :menu-list="routerList"></menuList>
            </div>
        </div> -->


            <div class="phone" ref="phone">

                <div v-for="item of routerList" :key="item.path" class="phoneDiv" @click.capture="change(item)">
                    <div v-if="item.meta.title != '产品'">
                        <a>{{ $t('navTitle', { title: item.meta.title, enTitle: item.meta.enTitle }) }}</a>
                        <div class="line" :class="{ 'active': $route.path==item.path }"></div>
                    </div>
                    <div v-else>
                        <el-dropdown hide-on-click trigger="click">
                            <span class="el-dropdown-link">
                                {{ $t('navTitle', { title: item.meta.title, enTitle: item.meta.enTitle }) }}
                            </span>
                            <el-dropdown-menu slot="dropdown" style="font-size: 15px !important;">
                                <div v-for="hhh of item.children" :key="hhh.path"
                                    @click="toDetail(item.name, hhh.name, hhh.path)">
                                    <el-dropdown-item :class="{ 'productActive': childrenName == hhh.name }">
                                        <!-- <a style="width: 100%;">{{ hhh.meta.title }}</a> -->
                                        <a style="width: 100%;">{{ hhh.meta.title }}</a>
                                    </el-dropdown-item>
                                </div>
                            </el-dropdown-menu>
                        </el-dropdown>
                        <div class="line" :class="{ 'active': curName==item.name }"></div>
                    </div>

                </div>
                
            </div>
           
           
        </div>
    </div>

</template>

<script>
import menuList from '@/components/menu.vue'
import changeLanguage from './changeLanguage.vue';
import { routerList } from '@/router/router'
export default {
    name: 'navigationBar',
    components: {
        menuList,
        changeLanguage
    },
    data() {
        return {
            routerList: [],
            left: 0,
            count: 0,
            curName: localStorage.getItem('cueNavName') || 'home',
            childrenName: '',
            language: localStorage.getItem('change-language'),
            curNavName:localStorage.getItem('cueNavName') || 'home'
        };
    },
    mounted() {
        this.routerList = routerList.filter((item) => item.meta.show)
        this.$bus.$on('closeMenu', (name) => {
            this.curName = name
            localStorage.setItem('cueNavName',name)
            this.$refs.phoneMenu.style.display = 'none'
        })
        this.$bus.$on('changeName', (name) => {
            this.curName = name
            localStorage.setItem('cueNavName',name)
        })
        this.$bus.$on('changeChildName', (name) => {

            this.childrenName = name
        })


        // 获取手机版本菜单dom
        // console.log(this.$refs.phone, 555)
       
        // let width = 0
        // this.$nextTick(() => {
        //     for (let i = 0; i < allNav.length; i++) {

        //         if (i == 0 || i == 1 || i == 2) {
        //             width += Number(window.getComputedStyle(allNav[i]).getPropertyValue('width').split('px')[0]) + 20

        //         }
        //     }
        //     this.$refs.phone.style.width = width - 35 + 'px'
        //     console.log(this.$refs.phone.style.width)
        // })

        const _this = this
        
        this.$nextTick(() => {


            window.onresize = function () {
                _this.changePhoneWidth(_this)
            }


            _this.changePhoneWidth(_this)

        })
    },
    methods: {
        changePhoneWidth(_this) {
            let allNav = document.getElementsByClassName('phoneDiv')
            if (document.body.clientWidth <= 600) {

                let width = 0

                for (let i = 0; i < allNav.length; i++) {

                    if (i == 0 || i == 1 || i == 2) {
                        width += Number(window.getComputedStyle(allNav[i]).getPropertyValue('width').split('px')[0]) + 20

                    }
                }
                _this.$refs.phone.style.width = width - 35 + 'px'
                _this.$refs.phone.style.overflowX = 'auto'


            } else {
                let width = 0

                for (let i = 0; i < allNav.length; i++) {
                    width += Number(window.getComputedStyle(allNav[i]).getPropertyValue('width').split('px')[0]) + 20
                }
                _this.$refs.phone.style.width = width + 'px'

            }
        },
        toDetail(fuName, name, path) {
            this.childrenName = name
            localStorage.setItem('cueNavName',fuName)
            this.curName = fuName
            this.$router.push(
                {
                    path
                }
            )
        },
        change(info) {
            this.curName = info.name
            localStorage.setItem('cueNavName',info.name)
            if (!info.children) {
                this.$router.push(
                    {
                        path: info.path
                        // name: info.name
                    }
                )
            } else {
                this.childrenName = info.children[info.children.length - 1].name

                this.$router.push(
                    {
                        path: info.children[info.children.length - 1].path
                        // name: info.children[0].name
                    }
                )
            }
        },
        closeMenu() {
            this.$refs.phoneMenu.style.display = 'none'
        },
        openMenu() {
            this.$refs.phoneMenu.style.display = 'block'
        }
    }
};
</script>
<style lang="scss" scoped>
.nav {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fff;
    color: black;
// height: 200px;
}

.left{
    display: flex;
    flex-direction: column;
    align-items: center;
}

.phoneChange{
    display: none;
    // height: 1rem;
    padding: 0;
    line-height: 1.5rem;
}

.left-title {
    display: flex;
    align-items: center;
    font-weight: bolder;
    font-size: 1.2rem;
    text-wrap: nowrap;
    

    .left-title-phone {
        display: none;
        line-height: 1rem;
    }

    img {
        // width: 5rem;
        height: 4rem;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 15px;
        flex: 1;
    }
}

.phoneMenu {
    position: absolute;
    z-index: 999999999 !important;
    display: none;
    transition: all ease 3s !important;
    // height: 0;
    left: 0;
    top: 0;
    width: 100%;
    height: 100vh;
    background-color: rgba(255, 255, 255, 0.9);

    .top {
        display: none;
        height: 5rem;
        display: flex;
        align-items: center;
        font-size: 1.5rem;
        font-weight: bolder;
        background-color: rgba(255, 255, 255, 0.9);
        border-bottom: 1px solid #e9e6e6;
        justify-content: center;
        align-items: center;

        .top_icon {
            width: 90%;
        }
    }
}

.head {
    width: 90%;
    height: 5rem;
    // line-height: 5rem;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;

}


.phone {
    line-height: 5rem;
    flex-shrink: 0;
    display: none;
    box-sizing: border-box;
    overflow-x: scroll;
    /* 开启横向滚动（必启） */
    overflow-y: hidden;
    /* 禁用纵向滚动，避免多余滚动条 */
    white-space: nowrap;
    /* 子元素不换行，保证横向排列 */
    // width: 50%;
    /* 适配移动端宽度 */
    // height: 5rem;              /* 与导航栏高度一致 */
    // line-height: 5rem;         /* 文字垂直居中 */
    /* 触摸滚动兼容性 */
    // -webkit-overflow-scrolling: touch;
    // touch-action: pan-x;

    // /* 1. 显示滚动条（Chrome/Safari 核心） */
    // &::-webkit-scrollbar {
    //     height: 2px !important;
    //     /* 滚动条高度（横向滚动条控制高度） */
    //     width: 6px;
    //     /* 纵向滚动条宽度（此处无用，仅作兼容） */
    //     display: none !important;
    //     /* 强制显示滚动条，覆盖默认隐藏 */
    // }

    // /* 2. 滚动条轨道样式（背景部分） */
    // &::-webkit-scrollbar-track {
    //     background: #f1f1f1;
    //     /* 轨道背景色 */
    //     border-radius: 10px;
    //     /* 轨道圆角（更美观） */
    //     margin: 0 5px;
    //     /* 轨道左右留空，避免贴边 */
    // }

    // /* 3. 滚动条滑块样式（可拖动部分） */
    // &::-webkit-scrollbar-thumb {
    //     background: #c1c1c1;
    //     /* 滑块默认颜色 */
    //     border-radius: 10px;
    //     /* 滑块圆角 */
    //     transition: background 0.3s ease;
    //     /*  hover 过渡效果 */
    // }

    // /* 4. 滚动条滑块 hover 样式 */
    // &::-webkit-scrollbar-thumb:hover {
    //     background: #999;
    //     /* 滑块 hover 加深色 */
    // }

    // /* 5. 兼容 Firefox 浏览器 */
    // scrollbar-width: thin;
    // /* Firefox 滚动条宽度（thin=细，auto=默认） */
    // scrollbar-color: #c1c1c1 #f1f1f1;
    /* Firefox 滑块色 + 轨道色 */
}

.phoneDiv {
    flex-shrink: 0;
    cursor: pointer;
    margin: 0 10px;
    display: inline-block;
}

.firstHead {
    // width: 40%;
    height: 5rem;
    
    background-color: aliceblue;
    display: flex;
    align-items: center;

}

.firstHead .ul {
    flex-shrink: 0 !important;
    // border: 2px solid red;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    width: 100%;
    height: 100%;
    line-height: 5rem;
    background-color: #fff;
    line-height: 5rem;
}

// .icon3,
// .icon2 {
//     display: flex; 
//     height: 5rem;
//     align-items: center;
//     border: 2px solid red;

// }


.List {
    font-size: 1rem !important;
    list-style-type: none;
    margin: 0px;
    padding-top: 0px;
    padding-bottom: 0px;
    padding-left: 0px;
    padding-right: 0px;
}

.List * {
    list-style-type: none;
    margin: 0px;
    padding-top: 0px;
    padding-bottom: 0px;
    padding-left: 0px;
    padding-right: 0px;
   
}

.firstHead div.ul div.li {
    position: relative;
    flex-shrink: 0 !important;
    color: #999 !important;
    // color: black !important;
    height: 5rem;
    // line-height: 5rem;
    margin: 0px 10px 0px 10px;
    text-align: center;
    font-family: "微软雅黑";
    font-size: 20px;
    color: #fefefd;
    cursor: pointer;

}

.firstHead div.ul div.li:hover {
    color: #000 !important;

}

.firstHead div.ul div.li:hover .line {
    display: block;
}

.line {
    height: 3px;
    background: #000;
    margin-top: -3px;
    display: none;
    position: relative;
    top: -10px;
}

.active {
    display: block !important;
}

.List .content {
    position: absolute;
    min-width: 180px;
    text-align: center;
    background-color: #fff;
    display: none;
    z-index: 999;
    border-radius: 5px;
    overflow: hidden;
    left: 50%;
    transform: translateX(-50%);
    text-wrap: nowrap;
}

.List .content>li {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    box-sizing: border-box;
    height: 60px;
    line-height: 60px;
    // border-bottom: 1px solid #999;
    font-family: "微软雅黑";
    cursor: pointer;
    padding: 0 1rem !important;

}

.content a {
    text-decoration: none;
    color: #999;
}

.content a:hover {
    color: #000;
}

.content li:hover {
    background-color: #f7f7f7;
}

.productActive {
    background-color: #f7f7f7;

    a {
        color: #000;
    }
}

.List:hover .content {
    display: block;
}

.headTitle {
    display: none;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translateX(-50%) translateY(-50%);
    text-align: center;
    font-weight: bolder;
    font-size: 1.2rem;
    text-wrap: nowrap;
}

.icon {
    display: none;
    font-size: 1.5rem;
}

// @media screen and (min-width: 601px) and (max-width: 992px) {

//     .firstHead {
//         width: 55%;

//     }
// }

@media screen and (max-width: 992px) {
    
    
    .left-title-pc {
        display: none !important;
    }

    .left-title-phone {
        display: block !important;
    }

    // .left-title {
    //     display: block !important;
    // }

    .icon {
        display: block !important;
    }

    .firstHead {
        display: none !important;
    }

    .headTitle {
        display: block !important;
    }

    .phone {
        display: flex !important;
        overflow-x: auto;
    }

    .left-title {
        img {
            height: 2.6rem !important;
            //    width: 100% !important;

        }
    }
    .phoneChange{
        display: block;
    }

}
</style>
<style lang="scss">
.el-dropdown-menu__item:hover {
    background-color: #f7f7f7 !important;
    color: #000 !important;

}

.el-dropdown {
    color: #000;
}

.el-dropdown-link {
    font-size: 16px !important;
}
</style>
